import { FCC, ReactElement } from 'react'

export interface ConditionalWrapperProps {
  condition: boolean
  wrapper: (el: ReactElement) => ReactElement
  children: ReactElement
}

export const ConditionalWrapper: FCC<ConditionalWrapperProps> = ({
  condition,
  wrapper,
  children,
}): ReactElement => (condition ? wrapper(children) : children)
